import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { FilterConfig, FilterContext, FilterData, FiltersState } from './types';

const initialState: FiltersState = {
  filters: {},
  configs: {},
};

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilters: (
      state: FiltersState,
      action: PayloadAction<{ context: FilterContext; filters: FilterData }>,
    ) => {
      const { context, filters } = action.payload;
      state.filters[context] = filters;
    },
    updateFilters: (
      state: FiltersState,
      action: PayloadAction<{
        context: FilterContext;
        filters: Partial<FilterData>;
      }>,
    ) => {
      const { context, filters: updatedFilters } = action.payload;
      if (!state.filters[context]) {
        state.filters[context] = {};
      }
      state.filters[context] = {
        ...state.filters[context],
        ...updatedFilters,
      };
    },
    resetFilters: (
      state: FiltersState,
      action: PayloadAction<{ context: FilterContext }>,
    ) => {
      const { context } = action.payload;
      state.filters[context] = {};
    },
    setFilterConfig: (
      state: FiltersState,
      action: PayloadAction<{ context: FilterContext; config: FilterConfig }>,
    ) => {
      const { context, config } = action.payload;
      state.configs[context] = config;
    },
    clearFilters: (state: FiltersState) => {
      state.filters = {};
      state.configs = {};
    },
  },
});

export const {
  setFilters,
  updateFilters,
  resetFilters,
  setFilterConfig,
  clearFilters,
} = filtersSlice.actions;

const reducer = { filters: filtersSlice.reducer };

export default reducer;
